import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, RoundDoneIcon, Text, useResponsive } from '@common-fe/common-fe';

import { ModalWrapper } from '@/components';

const headerText = 'Your claim has been approved!';
const description = 'Your payment is on the way.';

interface Props {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
  onSubmit: () => void;
}

export const SuccessOcrTransactionInfoModal: React.FC<Props> = ({ visible, onSetVisible, onSubmit }) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  return (
    <ModalWrapper
      testId="SuccessContributionModal_modal_wrapper"
      visible={visible}
      onSetVisible={onSetVisible}
    >
      <Box align="center" pad={{ vertical: 'spacing24', horizontal: 'spacing128' }}>
        <RoundDoneIcon />
        <Text
          data-testid="SuccessContributionModal_modal_header"
          margin={{ vertical: 'spacing12' }}
          textAlign="center"
          size="24px"
          weight={700}
        >
          {headerText}
        </Text>

        <Text
          data-testid="SuccessContributionModal_modal_help-text"
          margin={{ bottom: 'spacing24' }}
          textAlign="center"
        >
          {description}
        </Text>
        <AppButton
          testId="SuccessContributionModal_modal"
          onClick={onSubmit}
          width={isMobile ? '100%' : '200px'}
        >
          {t('Go to Expense Details!')}
        </AppButton>
      </Box>
    </ModalWrapper>
  );
};
